import { IntegrationsApiPageContent } from "@/pages/integrations/api/integrations-api-page-content";
import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { StyledPageWrapper } from "@/pages/integrations/shared/integrations.styles";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import { useTimeout } from "usehooks-ts";

type TProps = {};

export const IntegrationsApiPage: FC<TProps> = observer(() => {
  const [ready, setReady] = useState(false);

  useTimeout(() => {
    setReady(true);
  }, 100);

  return (
    <StyledPageWrapper visible={ready}>
      <IntegrationsPageHeader />
      <IntegrationsApiPageContent />
    </StyledPageWrapper>
  );
});
